import { RuleId } from '@wix/a11y-rules';
import { normalizeKeyForColorContrastCrossIssue } from '@wix/a11y-wizard-common';
import { isOptional } from '@wix/seo-common-core';
export const getCrossColorContrastIssuesByBreakpoint = (getIsComponentInGlobalSection, results) => {
  const pageEntries = Object.values(results);

  // Filter out pages with COLOR_CONTRAST errors early
  const validPageEntries = pageEntries.filter(page => {
    const colorContrastResults = (page == null ? void 0 : page[RuleId.COLOR_CONTRAST]) ?? [];
    // Include page only if it has no COLOR_CONTRAST results with error status
    return colorContrastResults.every(result => {
      var _result$result;
      return ((_result$result = result.result) == null ? void 0 : _result$result.status) !== 'error';
    });
  });
  const [firstPageResults, ...otherPages] = validPageEntries;
  if (!firstPageResults || !firstPageResults[RuleId.COLOR_CONTRAST]) {
    return null;
  }
  const crossIssuesByBreakpoint = {};
  for (const firstResultRaw of firstPageResults[RuleId.COLOR_CONTRAST]) {
    var _firstResult$metadata, _firstResult$result, _firstResult$result2;
    const firstResult = firstResultRaw;
    const breakpointId = firstResult == null || (_firstResult$metadata = firstResult.metadata) == null ? void 0 : _firstResult$metadata.breakpointId;
    if (!breakpointId) {
      continue;
    }

    // Skip if first page has error status for this breakpoint
    if (((_firstResult$result = firstResult.result) == null ? void 0 : _firstResult$result.status) === 'error') {
      continue;
    }
    if (isOptional((_firstResult$result2 = firstResult.result) == null ? void 0 : _firstResult$result2.failedElements)) {
      return null;
    }
    const pageDataWithColorContrast = otherPages.map((page, pageIdx) => {
      var _match$result;
      const match = ((page == null ? void 0 : page[RuleId.COLOR_CONTRAST]) ?? []).find(r => {
        var _r$metadata;
        return (r == null || (_r$metadata = r.metadata) == null ? void 0 : _r$metadata.breakpointId) === breakpointId;
      });
      const pageId = Object.keys(results)[pageIdx + 1];
      return {
        keySet: new Set(((match == null || (_match$result = match.result) == null ? void 0 : _match$result.failedElements) ?? []).map(normalizeKeyForColorContrastCrossIssue)),
        match,
        pageId
      };
    }).filter(_ref => {
      var _match$result2;
      let {
        match
      } = _ref;
      return match && ((_match$result2 = match.result) == null ? void 0 : _match$result2.failedElements) !== undefined;
    }); // Only include pages with COLOR_CONTRAST results and failedElements

    const otherKeySets = pageDataWithColorContrast.map(_ref2 => {
      let {
        keySet
      } = _ref2;
      return keySet;
    });
    const isShared = el => {
      const key = normalizeKeyForColorContrastCrossIssue(el);
      // Strict 100% matching: element must be in ALL pages
      const isInAllPages = otherKeySets.length > 0 && otherKeySets.every(keySet => keySet.has(key));
      const isInGlobalSection = getIsComponentInGlobalSection(el.elementId);
      const passesIncompleteCheck = !el.isIncomplete;
      const result = passesIncompleteCheck && (isInGlobalSection || isInAllPages);
      return result;
    };
    const sharedFailedElements = firstResult.result.failedElements.filter(el => isShared(el));
    crossIssuesByBreakpoint[breakpointId] = {
      ...firstResult,
      result: {
        ...firstResult.result,
        failedElements: sharedFailedElements,
        status: sharedFailedElements.length === 0 ? 'passed' : firstResult.result.status
      }
    };
  }
  return Object.keys(crossIssuesByBreakpoint).length > 0 ? crossIssuesByBreakpoint : null;
};
//# sourceMappingURL=get-cross-color-contrast-issues-by-breakpoint.js.map